import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { loginFeature } from './store/reducers';
import * as LoginActions from './store/actions';
import { MatIconModule } from '@angular/material/icon';
import { PasswordToggleDirective } from '../../shared/directives/password-toggle.directive';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
    PasswordToggleDirective,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private store = inject(Store);
  private fb = inject(FormBuilder);
  private snackbar = inject(MatSnackBar);
  protected themeService = inject(ThemeService);

  loading$ = this.store.select(loginFeature.selectLoading);
  loginForm: FormGroup;
  currentYear: number;

  constructor() {
    this.currentYear = new Date().getFullYear();
    this.loginForm = this.fb.group({
      user: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  onSubmit() {
    console.log('submit');
    if (this.loginForm.invalid) {
      this.snackbar.open(
        'Verifica los campos e intenta nuevamente',
        undefined,
        {
          panelClass: 'snackbar-error',
        }
      );
      return;
    }

    const value = this.loginForm.value;

    this.store.dispatch(LoginActions.login({ ...value }));
  }
}
